import Splide from '@splidejs/splide';

const MOBILE_BREAKPOINT = 768;

function createSplideFromGrid(block) {
    const grid = block.querySelector('.wp-block-ssm-block-grid__grid');
    if (!grid) return null;

    const cards = Array.from(grid.children);
    if (!cards.length) return null;

    const splide = document.createElement('div');
    splide.className = 'splide block-grid__mobile-carousel';

    const track = document.createElement('div');
    track.className = 'splide__track';

    const list = document.createElement('div');
    list.className = 'splide__list';

    cards.forEach((card) => {
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.appendChild(card);
        list.appendChild(slide);
    });

    track.appendChild(list);
    splide.appendChild(track);

    const arrows = document.createElement('div');
    arrows.className = 'splide__arrows';

    const prev = document.createElement('button');
    prev.className = 'splide__arrow splide__arrow--prev';
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous');

    const next = document.createElement('button');
    next.className = 'splide__arrow splide__arrow--next';
    next.type = 'button';
    next.setAttribute('aria-label', 'Next');

    arrows.appendChild(prev);
    arrows.appendChild(next);

    const pagination = document.createElement('div');
    pagination.className = 'splide__pagination';

    splide.appendChild(arrows);
    splide.appendChild(pagination);

    grid.after(splide);

    return { splide, grid, cards, list };
}

export function destroySplideInstance(block) {
    const data = block._blockGrid;
    if (!data?.splideInstance) return;

    data.splideInstance.destroy();

    const { splideEl, grid, cards } = data;

    // move cards back to grid
    cards.forEach((card) => {
        grid.appendChild(card);
    });

    splideEl.remove();
    block._blockGrid = null;
}

export function initSplideInstance(block) {
    if (block._blockGrid?.splideInstance) return;

    const data = createSplideFromGrid(block);

    if (!data) return;

    const splide = new Splide(data.splide, {
        type: 'loop',
        pagination: false,
        arrows: true,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
    });

    if(!splide) return;

    splide.mount();

    block._blockGrid = {
        splideInstance: splide,
        splideEl: data.splide,
        grid: data.grid,
        cards: data.cards,
    };
}

export function BlockGridCarousel() {
    const blocks = document.querySelectorAll('.wp-block-ssm-block-grid.is-style-carousel');
    if (!blocks?.length) return;

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const handleChange = () => {
        blocks.forEach((block) => {
            if (mql.matches) {
                initSplideInstance(block);
            } else {
                destroySplideInstance(block);
            }
        });
    };

    handleChange();
    mql.addEventListener('change', handleChange);
}
